import React, {Component} from "react";
import './Admin.css';
import 'react-toastify/dist/ReactToastify.css';
import PisaasInstanceInfo from "../instances/PisaasInstanceInfo"
import InstancesListView from "./InstancesListView";


export default class RunningInstances extends Component {

    renderPisaasInstanceInfo = (pisaasInstances, requesting, searchTerm, isList) => {
        if (!pisaasInstances || pisaasInstances.length === 0) {
            return (
                <>
                    {requesting ?
                        <div className={"loading-container"} data-testid="admin.loading.container">
                            Requesting...
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                        </div>
                        :
                        <div className={"pisaas-admin-container"} data-testid="admin.instances.container">
                            <span className="no-instances-text gap-bottom-4" data-testid="admin.instances.text">There are no running instances.</span>
                        </div>}
                </>);
        } else {
            const filteredInstances = this.filterInstancesBySearch(searchTerm, pisaasInstances)
            if (isList) {
                return (
                        <InstancesListView pisaasInstances={filteredInstances} isAdmin={this.props.isAdmin} refreshPisaasInstances={this.props.refreshPisaasInstances}/>
                    )
            } else {
                return (
                    <div>
                        {requesting ?
                            <div className={"loading-container"} data-testid="admin.loading.container">
                                Requesting...
                                <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            </div>
                            : null}
                        {filteredInstances.map((pisaasInstance, index) =>
                            <PisaasInstanceInfo isAdmin={this.props.isAdmin} refreshPisaasInstances={this.props.refreshPisaasInstances} piSaasInstance={pisaasInstance} key={index}/>
                        )}
                    </div>
                )
            }
        }
    };

    filterInstancesBySearch = (searchTerm, pisaasInstances) => {
        return pisaasInstances.filter((instance) => {
            return instance.email.includes(searchTerm) || instance.domain.includes(searchTerm) || instance.trypi_url?.includes(searchTerm) || (instance.package_id === 8 && "trypi".includes(searchTerm)) || (instance.package_id === 7 && "pisaas".includes(searchTerm))
        })
    }


    render() {
        return (
            <div>
                {this.renderPisaasInstanceInfo(this.props.runningInstances, this.props.requestingPisaasInstances, this.props.searchTerm, this.props.isList)}
            </div>
        );
    }
}
